<template>
  <div>
    <b-row>
      <b-col>
        <search-box v-model="query" />
      </b-col>
      <b-col class="text-right">
        <b-button
          v-if="
            auth.user.selectedAccess.roleLevel > 1 &&
            auth.user.selectedAccess.can_modify_settings
          "
          v-router-link="addChain"
          variant="outline-primary"
        >
          <span v-label-key="'ADD_CHAIN'">Add Chain</span>
        </b-button>
      </b-col>
    </b-row>
    <b-table
      id="chains-table"
      ref="chainsTable"
      :per-page="0"
      :current-page="currentPage"
      :items="chains"
      :fields="fields"
      :busy="loading"
      show-empty
      striped
      hover
      responsive
      @sort-changed="handleSortChange"
    >
      <template v-slot:cell(name)="data">
        <router-link :to="{ name: 'chain-detail', params: data.item }">
          {{ data.item.name }}
        </router-link>
      </template>
      <template v-slot:cell(distributor_name)="data">
        <router-link
          v-if="auth.user.selectedAccess.roleLevel > 2"
          :to="{
            name: 'distributor-detail',
            params: { id: data.item.distributor_id },
          }"
        >
          {{ data.item.distributor_name }}
        </router-link>
        <span v-if="auth.user.selectedAccess.roleLevel <= 2">{{
          data.item.distributor_name
        }}</span>
      </template>
      <template v-slot:cell(subdistributor_name)="data">
        <router-link
          v-if="
            auth.user.selectedAccess.roleLevel > 1 &&
            data.item.subdistributor_id
          "
          :to="{
            name: 'subdistributor-detail',
            params: { id: data.item.subdistributor_id },
          }"
        >
          {{ data.item.subdistributor_name }}
        </router-link>
        <span v-if="auth.user.selectedAccess.roleLevel <= 1">{{
          data.item.subdistributor_name || "-"
        }}</span>
      </template>
      <template v-slot:table-busy>
        <loading-spinner />
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="total"
      :per-page="perPage"
      align="right"
      aria-controls="chains-table"
      @change="pageChanged"
    />
  </div>
</template>
<script>
import debounce from 'lodash.debounce';
import $api from "@/services/api";
import $auth from "@/services/auth";
import $search from "@/services/search";
import LoadingSpinner from "@/components/LoadingSpinner";
import SearchBox from "@/components/SearchBox";
import { mapGetters } from "vuex";

export default {
  name: "ChainList",
  components: {
    LoadingSpinner,
    SearchBox,
  },
  props: ['distributor_id', 'subdistributor_id'],
  data() {
    return {
      auth: $auth,
      search: $search,
      query: null,
      chains: [],
      perPage: 10,
      currentPage: 1,
      total: 0,
      orderBy: '',
      isOrderByDesc: false,
      loading: false,
    };
  },

  computed: {
    ...mapGetters("translations", {
      getLabel: "getLabel",
    }),
    fields() {
      return [
        { key: "id", label: this.getLabel("ID"), sortable: true },
        { key: "name", label: this.getLabel("NAME"), sortable: true },
        {
          key: "distributor_name",
          label: this.getLabel("DISTRIBUTOR"),
          sortable: true,
        },
        {
          key: "subdistributor_name",
          label: this.getLabel("SUBDISTRIBUTOR"),
          sortable: true,
        },
      ];
    },
    totalRows() {
      return (
        this.$store.state.global.chains &&
        this.search(this.$store.state.global.chains, this.query, [
          "name",
          "distributor_name",
          "subdistributor_name",
        ]).length
      );
    },

    addChain() {
      if (this.$route.name === "chain-list") {
        return { name: "chain-editor" };
      }

      return {
        name: "chain-editor",
        query: {
          distributor_id: this.$store.state.global.params.distributor_id,
          subdistributor_id: this.$store.state.global.params.subdistributor_id,
        },
      };
    },
  },
  watch:{
    query(newValue) {
      this.debounceSearch(newValue);
    }
  },
  beforeDestroy() {
    if (this.debounceSearch && this.debounceSearch.cancel) {
      this.debounceSearch.cancel();
    }
  },
  created() {
    this.debounceSearch = debounce(() => {
      this.currentPage = 1;
      this.refreshData();
    }, 500);
    this.refreshData();
  },
  methods: {
    pageChanged(page) {
      this.currentPage = page;
      this.refreshData();
    },
    handleSortChange(e){
      this.orderBy = e.sortBy;
      this.isOrderByDesc = e.sortDesc;
      this.refreshData();
    },
    refreshData() {
      this.loading = true;
      this.chains = [];

      let tempQuery = this.getListQuery();

      tempQuery += `&skip=${(this.currentPage - 1) * this.perPage}&take=${
        this.perPage
      }`;

      $api
        .get("/v1/dashboard/chains" + tempQuery)
        .then((response) => {
          this.chains = response.data;
          this.total = response.total;
          this.$emit("loaded", response.data);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.$refs.chainsTable.refresh();
        });
    },
    getListQuery() {
      const payload = {
        distributor_id: this.distributor_id,
        subdistributor_id: this.subdistributor_id,
        orderBy: this.orderBy? this.orderBy : null,
        isOrderByDesc: this.orderBy ? this.isOrderByDesc : null,
        searchKey: this.query ? this.query : null,
      };

      let tempQuery = "?";
      for (const key in payload) {
        if (payload[key] !== null && payload[key] !== undefined) {
          tempQuery += `&${key}=${payload[key]}`;
        }
      }

      return tempQuery;
    },
  },
};
</script>
<style scoped>
a {
  color: black;
}
</style>
